import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
export type NotificationFragment = { id: string, mediums: Array<Types.MemoMedium>, message: string, read: boolean, severity: Types.MemoSeverity, tag: Types.MemoTag, time: any, title: string, userId: string, relatedEntities: Array<{ advertiser: { id: string, name: string } | null, kpi: { id: string, name: string } | null, offer: { id: string, name: string } | null, publisher: { id: string, name: string } | null }> };

export const NotificationFragmentDoc = gql`
    fragment Notification on Memo {
  id
  mediums
  message
  read
  relatedEntities {
    advertiser {
      id
      name
    }
    kpi {
      id
      name
    }
    offer {
      id
      name
    }
    publisher {
      id
      name
    }
  }
  severity
  tag
  time
  title
  userId
}
    `;